import { GoogleProductName } from '../googleIntegration/types.ts';

import { AccountType } from './types.ts';

export const originProductToAccountTypeMap = {
  [GoogleProductName.AD_MANAGER]: AccountType.GAM,
  [GoogleProductName.ADMOB]: AccountType.ADMOB,
};
